import { datadogLogger } from '@fanduel/casino-datadog-logger';
import cookie from 'js-cookie';

import config from '@/config';
import { getAuthCookies } from '@/features/cookies/auth-cookies';
import { PLATFORM_COOKIES } from '@/features/cookies/platform-cookies';
import {
  getPlatform,
  getUserId,
} from '@/features/game-context/platform-helpers';
import { DatadogSite } from '@/features/logging/logger';

export const initLogging = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const { sessionId } = getAuthCookies();

  const extraConfig = {
    globalContextRumEvents: {
      platform: getPlatform().toUpperCase(),
      brand: process.env.BRAND?.toUpperCase(),
      region: searchParams.get('region')?.toUpperCase(),
      product: process.env.PRODUCT?.toUpperCase(),
      userId: getUserId(),
      env: process.env.NODE_CONFIG_ENV,
      isQuickLaunch: cookie.get(PLATFORM_COOKIES.IS_QL) ?? false,
      [PLATFORM_COOKIES.ANDROID_APP_VERSION]: cookie.get(
        PLATFORM_COOKIES.ANDROID_APP_VERSION,
      ),
    },
    doNotLogList: [],
    blackListedAttributesList: [],
    debugMode: process.env.DISABLE_LOGGING === 'true',
    userId: getUserId() ?? undefined,
    sessionId,
  };

  datadogLogger.initialize(
    {
      applicationId: config.logging.applicationId,
      clientToken: config.logging.clientToken,
      site: config.logging.site as DatadogSite,
      service: config.logging.service,
      env: process.env.NODE_CONFIG_ENV,
      version: process.env.BUILD_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      silentMultipleInit: true,
    },
    extraConfig,
  );
};
